import { yupResolver } from "@hookform/resolvers/yup";
import { useDisclosure } from "@nextui-org/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { getFetcher, postFetcher, putFetcher } from "../services/api";
import { dirtyInput, isResponseErrorObject } from "../services/helpers";
import { usersValidation } from "../services/validation/users.validation";

export default function useUsers({ mutate }) {
    const {isOpen: isOpenModalForm, onOpen: onOpenModalForm, onOpenChange: onOpenChangeModalForm, onClose: onCloseModalForm} = useDisclosure();
    const [editId, setEditId] = useState(null);
    const [loadingEdit, setLoadingEdit] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const { control, handleSubmit, reset, watch, formState: { errors, isSubmitting, dirtyFields } } = useForm({resolver: yupResolver(usersValidation)});

    async function onClickEdit(id) {    
        try {
            setLoadingEdit(true);
            setIsEdit(true);
            const response = await getFetcher(`/api/users/find/${id}`);
            setEditId(id);      
            reset({
                fullName: response?.fullName,   
                email: response?.email,
                phoneNumber: response?.phoneNumber,
                address: response?.address,
                rolesIds: response?.roles.map((role) => role.role.name),
                companyIds: response?.companies.map((company) => company.companyId)
            });           
            onOpenChangeModalForm();
        } catch (error) {
            setLoadingEdit(false);
            toast.error('Error')
        } finally {
            setLoadingEdit(false);
        }
    }

    function onCloseForm() {
        setEditId(null);
        setIsEdit(false);
        reset({
            fullName: '',
            email: '',
            phoneNumber: '',
            address: '',
            rolesIds: [],
            companyIds: []
        });
        onCloseModalForm()
    }

    async function onSubmitForm(formData) {
        try {
            
            if (isEdit) {
                const filteredData = dirtyInput(dirtyFields, formData)
                console.log(filteredData);
                await putFetcher('/api/users/update-user', editId, filteredData);
                mutate()
                toast.success('Pengguna berhasil diubah!');
            } else {
                delete formData.confirmPassword
                await postFetcher('/api/users', formData);
                mutate()
                toast.success('Pengguna berhasil ditambah!');
            }
            onCloseForm();
        } catch (error) {
            isResponseErrorObject(error.response.data.message)
                ? Object.entries(error.response.data.message).forEach(([key, value]) => {
                    toast.error(value);
                })
                : toast.error(error.response.data.message)
        }
    }

    async function onGetUserPTSP() {
        try {
            
            await postFetcher('/api/users/migrate-users');
        } catch (error) {
            isResponseErrorObject(error.response.data.message)
                ? Object.entries(error.response.data.message).forEach(([key, value]) => {
                    toast.error(value);
                })
                : toast.error(error.response.data.message)
        }
    }

    return {
        modalForm: {
            isOpenModalForm,
            onOpenModalForm,
            onOpenChangeModalForm,
        },
        hookForm: {
            control, 
            watch,
            handleSubmit, 
            reset, 
            formState: { errors, isSubmitting, dirtyFields }
        },
        isEdit,
        loadingEdit,
        onClickEdit,
        onCloseForm,
        onSubmitForm,
        onGetUserPTSP,
    }
}